import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.css";
import TabButton from "./TabButton";
import TabContent from "./TabContent";
const Tabs = ({
  defaultActive,
  items,
  onChange,
  containerStyles,
  buttonsStyles,
  buttonStyle,
  activeButtonStyle,
  contentStyles,
  isScroll,
  actions,
  actionsKey,
}) => {
  const [activeKey, setActiveKey] = useState(defaultActive || items[0]?.key);

  const handleTabChange = useCallback(
    (key) => {
      setActiveKey(key);
      if (onChange) {
        onChange(key);
      }
    },
    [onChange],
  );
  return (
    <div className={`${styles["tabs-container"]} ${containerStyles}`}>
      <div
        className={`d-flex justify-content-between align-items-center ${isScroll ? styles["tabs-buttons-container-active"] : ""}`}
      >
        <div
          className={`${styles["tabs-buttons"]} ${
            buttonsStyles ? buttonsStyles : styles["tabs-buttons-default"]
          } `}
        >
          {items.map((item) => (
            <TabButton
              key={item.key}
              active={activeKey === item.key}
              onClick={() => handleTabChange(item.key)}
              label={item.label}
              buttonStyle={buttonStyle}
              activeButtonStyle={activeButtonStyle}
            />
          ))}
        </div>
        {actions && actionsKey ? (
          actionsKey == activeKey && (
            <div className={styles["tabs-actions"]}>{actions}</div>
          )
        ) : (
          <div className={styles["tabs-actions"]}>{actions}</div>
        )}
      </div>
      <div
        className={`${styles["tabs-content"]} ${
          contentStyles ? contentStyles : styles["tabs-content-default"]
        }`}
      >
        {items.map((item) => (
          <TabContent key={item.key} isActive={activeKey === item.key}>
            {item.children}
          </TabContent>
        ))}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  defaultActive: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node,
      children: PropTypes.node,
    }),
  ).isRequired,
  onChange: PropTypes.func,
  containerStyles: PropTypes.string,
  buttonsStyles: PropTypes.string,
  buttonStyle: PropTypes.string,
  activeButtonStyle: PropTypes.string,
  contentStyles: PropTypes.string,
  isScroll: PropTypes.bool,
  actions: PropTypes.node,
  actionsKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Tabs;
